import React from 'react';
import Select from 'react-select';

const Dropdown = ({ options, onChange, styles, selected }) => {

  return(
    <Select
      options={options}
      onChange={onChange}
      defaultValue={options[0]}
      styles={styles}
      isSearchable={false}
      value={options.find(option => option.value === selected.value)}
    />
  )
}

export default Dropdown;
